var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VDataTable',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.behaviors,"items-per-page":50}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }